import { render, staticRenderFns } from "./EtiquetaCampo.vue?vue&type=template&id=3b43edf0&scoped=true&"
import script from "./EtiquetaCampo.vue?vue&type=script&lang=js&"
export * from "./EtiquetaCampo.vue?vue&type=script&lang=js&"
import style0 from "./EtiquetaCampo.vue?vue&type=style&index=0&id=3b43edf0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b43edf0",
  null
  
)

export default component.exports